import { http } from '../api/http';

export type DeveloperRequestStatus = 'PENDING' | 'APPROVED' | 'REJECTED';

export interface DeveloperAccessRequest {
  id: string;
  userId: string;
  status: DeveloperRequestStatus;
  requestedAt: string;
  decidedAt?: string | null;
  decidedBy?: string | null;
  adminComments?: string | null;
  user?: {
    id: string;
    name: string;
    email: string;
    phone?: string | null;
  };
  reviewer?: {
    id: string;
    name: string;
    email: string;
  };
}

export interface DeveloperRequestListResponse {
  data: DeveloperAccessRequest[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const DeveloperRequestsService = {
  requestAccess() {
    return http<DeveloperAccessRequest>('/developer-requests', { method: 'POST' });
  },

  getMyRequest() {
    return http<DeveloperAccessRequest | null>('/developer-requests/me');
  },

  getAll(params?: { status?: DeveloperRequestStatus; page?: number; limit?: number }) {
    const search = new URLSearchParams();
    if (params?.status) search.set('status', params.status);
    if (params?.page) search.set('page', String(params.page));
    if (params?.limit) search.set('limit', String(params.limit));
    const qs = search.toString();
    return http<DeveloperRequestListResponse>(`/admin/developer-requests${qs ? `?${qs}` : ''}`);
  },

  review(id: string, data: { status: DeveloperRequestStatus; adminComments?: string }) {
    return http<DeveloperAccessRequest>(`/admin/developer-requests/${id}/decision`, {
      method: 'PATCH',
      body: data,
    });
  },
};
